export default __webpack_public_path__ + "static/media/img-api-cat-operational-cropped.51087145.png";